import FieldSet from '../../FieldSet';

import { TeamName } from './TeamName';

export class TeamFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TeamName];
  }

  get title() {
    return 'Team';
  }
}
